<template>
    <iframe class="specificComponent" :id="id" :src="config.url" ></iframe>
</template>

<script>
export default {
    props: {config:Object, shared: {type: Boolean, default: false}},
    data(){
        return {
            id: "cgsTest_" + new Date().getTime()
        }
    },
    mounted (){
    },
    methods:{
      resize(newHPx, newWPx){
        // console.log(newHPx, newWPx)
      }
    }
    
}
</script>

<style scoped>
.specificComponent{
    width: 100%;
    height: 100%;
    border: 0px;
}
</style>